import React from "react";
import { GridLayout } from "./Layouts/Grid";
import { TableLayout } from "./Layouts/Table";
import { StackedLayout } from "./Layouts/Stacked";
import "./CartItems.scss";
import Paragraph from '@arctheme-components/elements/Paragraph/Paragraph';
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../../entrypoints/theme";



export const CartItems = ({ settings }) => {
  const { section, blocks } = settings;
  const productLayout = section.product_layout;
    const isMobile = useMobileBreakpoint(mobileBreakpoint);
    const isLoggedIn = settings.globals.is_customer_logged_in; // Check if customer object exists

    const membershipBlock = blocks.length ? blocks.find((block) => block.type === "membership_perks") : null;



  return (
    <div className={`items-layout__${productLayout}`}>
         {isMobile && membershipBlock && !isLoggedIn && (
             <div 
             className="membership-perks rounded-xl p-2 mt-[20px]" 
             style={{ backgroundColor: membershipBlock.settings.background_color }}
           >
             <div className="flex items-start flex-col gap-2">
               <div className="flex items-center gap-2">
                 <div>
                 {membershipBlock.settings.icomoon_icon ? (
                 <span className={`${membershipBlock.settings.icomoon_icon} text-orange-600 text-[24px]`}></span>
               ) : membershipBlock.settings.icon ? (
                 <img 
                   src={membershipBlock.settings.icon} 
                   alt="Membership icon"
                   className="w-6 h-6"
                 />
               ) : null}
   
                 </div>
                 {membershipBlock.settings.title && (
                   <h3 className={membershipBlock.settings.title_style}>
                     {membershipBlock.settings.title}
                   </h3>
                 )}
                 </div>
               
               
               <div className="flex gap-3 items-center">
                 {membershipBlock.settings.description && (
                   <div className={membershipBlock.settings.description_style}>
                     {membershipBlock.settings.description}
                   </div>
                 )}
   
                 <div className="flex gap-2">
                   <a href="/account/register" className="b4--bold underline">
                     Sign up
                   </a>
                   <div>/</div>
                   <a href="/account/login" className="b4--bold underline">
                     Login
                   </a>
                 </div>
               </div>
             </div>
           </div>
        )}
      {productLayout === "table" ? (
        <TableLayout settings={settings} />
      ) : productLayout === "grid" ? (
        <GridLayout settings={settings} />
      ) : (
        <StackedLayout settings={settings} />
      )}
       {section.show_continue_shopping && ( <div className='pb-4 mt-4 hidden lg:block'>
          <a
            href='/collections/all'
            class='item-1 hover:underline py-[10px] mt-2'
          >
            Continue Shopping
          </a>
        </div>
         )}
    </div>
  );
};
